import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../Services/AppContext';
import { loadDOMComponent } from '../../../helpers';
import AclContextProvider from '../../../Modules/Acl/Components/AclContextProvider';
import { Provider } from 'react-redux';
import { store } from '../../../store/store';
import WizardWrapper from './WizardWrapper';

loadDOMComponent({
	selector: 'react-wizard',
	callback: ({ container }: { container: HTMLElement }) => {
		const wizardKey: string | null = container.getAttribute('wizardKey');
		const initialData: string | null = container.getAttribute('initialData');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider>
					<AclContextProvider>
						<>
							{wizardKey && (
								<WizardWrapper
									wizardKey={wizardKey}
									initialData={
										initialData ? JSON.parse(initialData) : undefined
									}
								/>
							)}
						</>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
